export const PAYMENTBAKERY = { id: 'pb', name: 'PaymentBakery', };

export const PAYMENTEZ = { id: 'paymentez', name: 'Paymentez', };

export const COOPENAE = { id: 'coopenae', name: 'Coopenae', };

export const REDEBAN = { id: 'redeban', name: 'Redeban' };

export const LAFISE = { id: 'lafise', name: 'Lafise', };

export const NIUBIZ = { id: 'niubiz',name: 'Niubiz', };

export const MOVII = { id: 'movii', name: 'Movii', };

const PAYMENT_PROCESSOR = [PAYMENTBAKERY, PAYMENTEZ, COOPENAE, REDEBAN, LAFISE, NIUBIZ, MOVII];

export default PAYMENT_PROCESSOR;
